export const TOKEN = 'TOKEN'

export const TOKEN_action = (data) => {
    return {
        type: TOKEN,
        info: data
    }
}